import { apiGetModel, getApi } from '../../../useApiHook';

export const getPatientByNhs = (auth, nhsNumber, callback) => {
  const model = apiGetModel('GetPatientByNhs', { NhsNumber: nhsNumber }, false, null, callback);
  getApi(auth, model);
};
